// extracted by mini-css-extract-plugin
export default {"eye-off-icon":"styles-module__eye-off-icon___656e52","eyeOffIcon":"styles-module__eye-off-icon___656e52"};